export default () => {
  return {
    mounted: (el, binding) => {
      if (binding.value) {
        el.classList.add('soft-disabled');
      }
    },
  };
};
